export const LANGUAGES = {
    pt: {
        code: 'pt-BR',
        currency: 'BRL'
    },
    default: 'pt'
};